class ShowItemsWithoutModelSwitch extends HTMLElement {
    constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
        this.initCheckboxState();
    }

    initCheckboxState() {
        // document.querySelectorAll('.flickity-enabled.product-card-images-slider').forEach(carousel => carousel.flickityGUID = null);

        const showItemsWithoutModel = localStorage.getItem('showItemsWithoutModel');
        if (showItemsWithoutModel === 'true') {
            this.checkbox.checked = true;
            this.closest('.enabled-show-items-without-model').classList.add('active-show-items-without-model');
            this.initSlideChange(1);
        } else {
            this.checkbox.checked = false;
            this.closest('.enabled-show-items-without-model').classList.remove('active-show-items-without-model');
            this.initSlideChange(0);
        }
    }

    initSlideChange(index) {
        const initSlideChange = setInterval(() => {
            const carousels = document.querySelectorAll('.flickity-enabled.product-card-images-slider');

            if (carousels.length === 0) {
                console.log('No Flickity carousels found');
            } else {
                this.slideChange(index);
                clearInterval(initSlideChange);
            }
        }, 500);
    }

    slideChange(index) {
        const carousels = document.querySelectorAll('.flickity-enabled.product-card-images-slider');
        if (carousels.length === 0) {
            console.log('No Flickity carousels found');
            return;
        }

        carousels.forEach(carousel => {
            const flkty = Flickity.data(carousel);
            if (flkty) {
                flkty.select(index, true, true);
                console.log('First initialized Flickity carousel with index:', index);
            }
            else if (carousel.flickityInstance) {
                carousel.flickityInstance.select(index, true, true);
                console.log('Seconds initialized Flickity carousel with index:', index);
            }
            else {
                console.log('No Flickity instance found for carousel');
            }
        });
    }

    onCheckboxChange(event) {
        event.preventDefault();
        const container = event.target.closest('.enabled-show-items-without-model');
        if (container) {
            container.classList.toggle('active-show-items-without-model');

            if (container.classList.contains('active-show-items-without-model')) {
                localStorage.setItem('showItemsWithoutModel', 'true');
                this.slideChange(1); // Reset to first slide when disabling
            } else {
                localStorage.removeItem('showItemsWithoutModel');
                this.slideChange(0); // Reset to first slide when enabling
            }
        }
    }
}

customElements.define('show-items-without-model', ShowItemsWithoutModelSwitch);